export namespace GamingAggregatorStatusId {
  export const Active = 1n;
  export const Suspended = 2n;
  export const Inactive = 3n;
}

export type GamingAggregatorStatusType =
  (typeof GamingAggregatorStatusId)[keyof typeof GamingAggregatorStatusId];
